import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter, OnDestroy, OnChanges } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { CommonService } from '../../../common/services/common.service';
import { OemConstants } from '../../../core/routing/services/oem/constants/oem.constants';
import { OemService } from '../../../core/routing/services/oem/oem.service';
import { first } from 'rxjs/internal/operators/first';
import { GetAllImageByAutoId, AssetImageViewModel } from '../../oem-portal/new-model-sku/upload-image/interfaces/upload-image.i';
import { GlobalConstants } from '../../../common/constants/global.constant';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CreatePartnerContentContentResponse, PartnerContentConfiguration, PartnerContentGroupPage, HotspotImageVideoContent } from '../new-partner-content/interfaces/new-partner-content.i';
import { AssetLibraryConstants } from '../../../core/routing/services/asset-library/constants/asset-library.constant';
import { environment } from '../../../../environments/environment';
import { RouterConstants } from '../../../../../src/app/core/routing/constants/app-paths.constant';
import { Router } from '@angular/router';

@Component({
  selector: 'iposcen-partner-content-page',
  templateUrl: './partner-content-page.component.html',
  styleUrls: ['./partner-content-page.component.scss']
})
export class PartnerContentPageComponent implements OnInit, OnDestroy {
  @ViewChild('colorpicker') colPicModal: ElementRef;
  @ViewChild('showModal') showModal: ElementRef;
  @Input() cntgrpdata: any;
  @Input() contentGroupType: string;
  @Input() pageNumber: number;
  @Input() mediaObjs: any;
  @Input() getPageData;
  @Output() readonly sendLayoutTocontentGrp = new EventEmitter<object>();
  @Output() readonly sendImageValues = new EventEmitter();

  selectedPartnerContentGroupPage: PartnerContentGroupPage;
  selectedContentGroupID: string;
  type: string;
  image: AssetImageViewModel[] = [];
  videoPlaying: HTMLVideoElement;
  tileVideo = [];
  imageVideData = [];
  uploadDateLable = 'Upload Date';
  fileNameLable = 'File Name';
  selectAutoId: string;
  setLable = this.uploadDateLable;
  uploadImageSortValue = GlobalConstants.UPLOAD_DATE;
  videoCount: number;
  selectedImage = false;
  selectedVideo = false;
  getType: string;
  imageData: any;
  imageSelected: any;
  storeImageData = new Map();
  imageButtonType;
  imagePreview: any;
  isVideoButton = false;
  isImageVideoButton = false;
  direction: string;
  bodyLabel: string;
  bodyLabelA: string;
  bodyLabelB: string;
  headingPlaceHolderText: string;
  bodyPlaceHolderText: string;
  headingLabel: string;
  smallText = GlobalConstants.SMALL;
  mediumText = GlobalConstants.MEDIUM;
  largeText = GlobalConstants.LARGE;
  bodyAPlaceHolder: string;
  bodyBPlaceHolder: string;
  userId = sessionStorage.getItem('userId');
  url = OemConstants.SKU_COMMON + AssetLibraryConstants.SLASH;
  pageGrpForm;
  pagePartnerGrpForm; // for OEM packaging
  contentName: string;
  systemID: string;
  imageMediaUrl: string;
  logoMediaUrl: string;
  videoMediaUrl: string;
  imageAvailable = false;
  videoAvailable = false;
  logoAvailable = false;
  imageAContent: any;
  imageBContent: any;
  heroImageContent: any;
  singleImageContent: any;
  videoContent: any;
  hotspotImageVideoContent: any;
  emptyAssetsText = OemConstants.NO_ASSETS;
  assetsData = [] as any;
  videoAssetsData = [] as any;
  isAssetDataEmpty: boolean;
  isVideoAssetDataEmpty: boolean;
  buttonType: string;
  disableImage = true;
  disableVideo = true;
  disableThumbnail = true;
  newHotspotImageVideoData = [];
  tabs = [{ id: 1, name: 'Hotspot 1', heading: 'Heading 1', visited: false }];
  maxTabs = 4;
  selectedFilter = 'All';
  isFontColorStruckOff = false;
  selectedTabIndex = 0;
  currentTabValue = 1;
  isMaxLengthReached = false;
  selectImageVideoHotspotData = [];
  hotspotJson = {
    1: GlobalConstants.HOTSPOT_ONE,
    2: GlobalConstants.HOTSPOT_TWO,
    3: GlobalConstants.THREE,
    4: GlobalConstants.FOUR
  }
  disabledSaveHotspot = false;
  showHeadingMessage = false;
  showImageVideoMessage = false;
  isHeadingMaxLengthReached = false;
  private modalRef: NgbModalRef;
  private ngUnsubscribe = new Subject<boolean>();
  aspectRatioText = GlobalConstants.DEVICE_LOGO_ASPECT_RATIO;

  constructor(private cmnSer: CommonService,
    private oemservice: OemService,
    private modalService: NgbModal,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.currentTabValue = 1;
    this.direction = this.cmnSer.direction;
    this.videoCount = this.tileVideo.length;
    this.headingLabel = GlobalConstants.PAGES_VIEW_HEADING;
    this.bodyLabel = GlobalConstants.PAGES_VIEW_BODY;
    this.bodyLabelA = 'Body A';
    this.bodyLabelB = 'Body B';
    this.headingPlaceHolderText = $localize`:@@partner-content-page.heading-placeholder.enter-heading:Enter Heading`;
    this.bodyPlaceHolderText = $localize`:@@partner-content-page.body-placeholder.enter-body-copy:Enter body copy here...`;
    this.bodyAPlaceHolder = $localize`:@@partner-content-page.bodyA-placeholder.enter-bodyA:Enter Body A`;
    this.bodyBPlaceHolder = $localize`:@@partner-content-page.bodyB-placeholder.enter-bodyB:Enter Body B`;
    setTimeout(() => {
      const updatePartnerContent: CreatePartnerContentContentResponse = this.cntgrpdata as CreatePartnerContentContentResponse;
      const partnerContent = updatePartnerContent.content;
      this.selectAutoId = partnerContent.autoID;
      let configurations;
      if (typeof partnerContent.configurations === 'string') {
        configurations = JSON.parse(partnerContent.configurations) as PartnerContentConfiguration;
      } else {
        configurations = partnerContent.configurations as PartnerContentConfiguration;
      }
      this.selectedPartnerContentGroupPage = configurations.contentGroupPages?.filter(ele => ele.pageNum === this.pageNumber)[0];
      this.contentName = configurations.contentName;
      this.systemID = configurations.systemID;
      this.prepareContentPage();
      this.getImageStatus();
      let bFS=this.pageGrpForm.hotspotImageVideoContent.bodyFontSize 
      this.pageGrpForm.hotspotImageVideoContent.bodyFontSize =  
        bFS === "12px" ? this.smallText :  bFS === "16px" ? this.largeText : this.mediumText ;
    }, 0);
    this.cmnSer.layoutObser
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(selected => {
        this.pageGrpForm.layout = selected;
        this.getImageStatus();
        this.emitPageDataToPreview();
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  // New page structure for OEM packaging
  prepareContentPage() {
    this.pageGrpForm = {
      id: this.cntgrpdata.content.contentID,
      bgcolor: this.selectedPartnerContentGroupPage ? this.selectedPartnerContentGroupPage.backgroundColor : '#0068B5',
      hcolor: this.selectedPartnerContentGroupPage ? this.selectedPartnerContentGroupPage.fontColor : '#ffffff',
      layout: this.selectedPartnerContentGroupPage ? this.getUILayoutIDByName(this.selectedPartnerContentGroupPage.uiLayout) : 4,
      logoMedia: {
        logoAssetId: (this.selectedPartnerContentGroupPage && this.selectedPartnerContentGroupPage.assetName) ? this.selectedPartnerContentGroupPage.assetID : '',
        name: this.selectedPartnerContentGroupPage ? this.selectedPartnerContentGroupPage.assetName : '',
        url: (this.selectedPartnerContentGroupPage && this.selectedPartnerContentGroupPage.assetID) ? environment.apiBaseUrlAsset + this.url + this.selectAutoId + OemConstants.SLASH_ASSETS
          + OemConstants.SLASH_LOGO + AssetLibraryConstants.SLASH + this.selectedPartnerContentGroupPage.assetID : '',
        format: (this.selectedPartnerContentGroupPage && this.selectedPartnerContentGroupPage.assetID) ? this.selectedPartnerContentGroupPage.assetType : ''
      },
      storedImageData: this.storeImageData
    };
    this.pageGrpForm.hotSpotCurrentTab = 0;
    if (this.selectedPartnerContentGroupPage && (this.selectedPartnerContentGroupPage.content.length === 1 || this.selectedPartnerContentGroupPage.content.length === 3)) {
      this.setPageContentOnEdit(this.selectedPartnerContentGroupPage, this.currentTabValue);
    } else {
      this.setPageContent(this.selectedPartnerContentGroupPage, this.currentTabValue);
    }
    const cgp=[];
    if (Object.keys(this.cntgrpdata.content.configurations.contentGroupPages).length !== 0) {
      for (let i = 0; i < Object.keys(this.cntgrpdata.content.configurations.contentGroupPages)?.length; i++) {
        cgp.push(this.cntgrpdata.content.configurations.contentGroupPages[i]);
      }
    }
    this.pageGrpForm.hotspots = 
      cgp.length>=this.pageNumber ?
      this.cntgrpdata.content.configurations.contentGroupPages[this.pageNumber-1].hotspots:{};
    this.pageGrpForm.hotspotImageVideoContent = 
      cgp.length>=this.pageNumber &&  (Object.keys(this.pageGrpForm.hotspots).length) ?
      this.cntgrpdata.content.configurations.contentGroupPages[this.pageNumber-1].hotspots.hotspot1: {};
    this.tabs=[];
    if (Object.keys(this.pageGrpForm.hotspots).length) {
      for (let i = 1; i <= Object.keys(this.pageGrpForm.hotspots)?.length; i++) {
        this.tabs.push({ id: i, name: `Hotspot ${i}`, heading: `Heading ${i}`, visited: false });
      }
    }
    else{
      this.tabs.push({ id: 1, name: `Hotspot 1`, heading: `Heading 1`, visited: false });
    }       
    this.emitPageDataToPreview('onlytopreview');
    this.sendLayoutTocontentGrp.emit(this.pageGrpForm.layout);
  }

  setPageContent(selectedPage, tabVal: number) {
    var imageAData, imageBData, heroImageData, singleImageData, videoData = {}, hotspotImageVideoData;
    this.pageGrpForm.layoutContent = [];
    this.pageGrpForm.HotspotContent = [];
    this.pageGrpForm.hotspots = {};
    if (selectedPage) {
      selectedPage.content.forEach(element => {
        if (element.alignment === 'leftTop') {
          imageAData = {
            imageAId: element.assetID,
            imageAName: element.assetName,
            imageAFileType: element.assetType,
            imageAUrl: (element.assetID) ? environment.apiBaseUrlAsset + this.url + this.selectAutoId + OemConstants.SLASH_ASSETS + OemConstants.SLASH_IMAGE + AssetLibraryConstants.SLASH + element.assetID : '',
            heading: element.title,
            bodyA: element.subTitle,
            bodyASize: this.fontSizeName(element.fontSize),
            position: element.alignment
          }
        } else if (element.alignment === 'leftBottom') {
          imageBData = {
            imageBId: element.assetID,
            imageBName: element.assetName,
            imageBFileType: element.assetType,
            imageBUrl: (element.assetID) ? environment.apiBaseUrlAsset + this.url + this.selectAutoId + OemConstants.SLASH_ASSETS + OemConstants.SLASH_IMAGE + AssetLibraryConstants.SLASH + element.assetID : '',
            heading: element.title,
            bodyB: element.subTitle,
            bodyBSize: this.fontSizeName(element.fontSize),
            position: element.alignment
          }
        } else if (element.alignment === 'right') {
          heroImageData = {
            heroImageId: element.assetID,
            heroImageName: element.assetName,
            heroImageFileType: element.assetType,
            heroImageUrl: (element.assetID) ? environment.apiBaseUrlAsset + this.url + this.selectAutoId + OemConstants.SLASH_ASSETS + OemConstants.SLASH_IMAGE + AssetLibraryConstants.SLASH + element.assetID : '',
            heading: element.title,
            body: element.subTitle,
            size: element.fontSize,
            position: element.alignment
          }
        } else if (element.alignment === 'i-center') {
          singleImageData = {
            singleImageId: element.assetID,
            imageName: element.assetName,
            imageFileType: element.assetType,
            imageUrl: (element.assetID) ? environment.apiBaseUrlAsset + this.url + this.selectAutoId + OemConstants.SLASH_ASSETS + OemConstants.SLASH_IMAGE + AssetLibraryConstants.SLASH + element.assetID : '',
            heading: element.title,
            body: element.subTitle,
            size: this.fontSizeName(element.fontSize),
            position: element.alignment
          }
        }
        else if (element.alignment === 'h-left') {
          hotspotImageVideoData = {
            assetID: element.assetID,
            assetName: element.assetName,
            assetType: element.assetType,
            heading: element.title,
            headingColor: element.headingColor,
            body: element.subTitle,
            bodyColor: element.bodyColor,
            bodyFontSize: this.fontSizeName(element.fontSize),
            imageAUrl: (element.assetID) ? environment.apiBaseUrlAsset + this.url + this.selectAutoId + OemConstants.SLASH_ASSETS + OemConstants.SLASH_IMAGE + AssetLibraryConstants.SLASH + element.assetID : '',
            videoUrl: (element.assetID) ? environment.apiBaseUrlAsset + this.url + this.selectAutoId + OemConstants.SLASH_ASSETS + OemConstants.SLASH_VIDEO + AssetLibraryConstants.SLASH + element.assetID : '',
          }
        }
        else if (element.alignment === 'v-center') {
          videoData = {
            videoId: element.assetID,
            videoName: element.assetName,
            videoFileType: element.assetType,
            videoUrl: (element.assetID) ? environment.apiBaseUrlAsset + this.url + this.selectAutoId + OemConstants.SLASH_ASSETS + OemConstants.SLASH_VIDEO + AssetLibraryConstants.SLASH + element.assetID : '',
            heading: element.title,
            body: element.subTitle,
            size: element.fontSize,
            position: element.alignment
          }
        }
      });
    } else {
      imageAData = { imageAId: '', imageAName: '', imageAFileType: '', imageAUrl: '', heading: '', bodyA: '', bodyASize: GlobalConstants.MEDIUM, position: 'leftTop' }
      imageBData = { imageBId: '', imageBName: '', imageBFileType: '', imageBUrl: '', heading: '', bodyB: '', bodyBSize: GlobalConstants.MEDIUM, position: 'leftBottom' }
      heroImageData = { heroImageId: '', heroImageName: '', heroImageFileType: '', heroImageUrl: '', heading: '', body: '', size: GlobalConstants.MEDIUM, position: 'right' }
      singleImageData = { singleImageId: '', imageName: '', imageFileType: '', imageUrl: '', heading: '', body: '', size: GlobalConstants.MEDIUM, position: 'i-center' }
      videoData = { videoId: '', videoName: '', videoFileType: '', videoUrl: '', heading: '', body: '', size: GlobalConstants.MEDIUM, position: 'v-center' }
      hotspotImageVideoData = { assetID: '', assetName: '', assetType: '', heading: '', body: '', bodyFontSize: GlobalConstants.MEDIUM, headingColor: '', bodyColor: '', videoUrl: '', imageAUrl: '' }
    }
    this.pageGrpForm.imageAContent = imageAData;
    this.pageGrpForm.imageBContent = imageBData;
    this.pageGrpForm.heroImageContent = heroImageData;
    this.pageGrpForm.singleImageContent = singleImageData;
    this.pageGrpForm.videoContent = videoData;
    this.pageGrpForm.hotspotImageVideoContent = hotspotImageVideoData;
    this.pageGrpForm.layoutContent.push(imageAData, imageBData, heroImageData, singleImageData, videoData);
  }

  setPageContentOnEdit(page, tabVal: number) {
    var imageAData, imageBData, heroImageData, singleImageData, videoData = {}, hotspotImageVideoData;
    this.pageGrpForm.layoutContent = [];
    this.pageGrpForm.HotspotContent = [];
    this.pageGrpForm.hotspots = {};
    page.content.forEach(ele => {
      if (ele.alignment === 'leftTop') {
        imageAData = {
          imageAId: ele.assetID,
          imageAName: ele.assetName,
          imageAFileType: ele.assetType,
          imageAUrl: (ele.assetID) ? environment.apiBaseUrlAsset + this.url + this.selectAutoId + OemConstants.SLASH_ASSETS + OemConstants.SLASH_IMAGE + AssetLibraryConstants.SLASH + ele.assetID : '',
          heading: ele.title,
          bodyA: ele.subTitle,
          bodyASize: this.fontSizeName(ele.fontSize),
          position: ele.alignment
        }
        this.pageGrpForm.imageAContent = imageAData;
        this.pageGrpForm.layoutContent.push(imageAData);
      } else if (ele.alignment === 'leftBottom') {
        imageBData = {
          imageBId: ele.assetID,
          imageBName: ele.assetName,
          imageBFileType: ele.assetType,
          imageBUrl: (ele.assetID) ? environment.apiBaseUrlAsset + this.url + this.selectAutoId + OemConstants.SLASH_ASSETS + OemConstants.SLASH_IMAGE + AssetLibraryConstants.SLASH + ele.assetID : '',
          heading: ele.title,
          bodyB: ele.subTitle,
          bodyBSize: this.fontSizeName(ele.fontSize),
          position: ele.alignment
        }
        this.pageGrpForm.imageBContent = imageBData;
        this.pageGrpForm.layoutContent.push(imageBData);
      } else if (ele.alignment === 'right') {
        heroImageData = {
          heroImageId: ele.assetID,
          heroImageName: ele.assetName,
          heroImageFileType: ele.assetType,
          heroImageUrl: (ele.assetID) ? environment.apiBaseUrlAsset + this.url + this.selectAutoId + OemConstants.SLASH_ASSETS + OemConstants.SLASH_IMAGE + AssetLibraryConstants.SLASH + ele.assetID : '',
          heading: ele.title,
          body: ele.subTitle,
          size: ele.fontSize,
          position: ele.alignment
        }
        singleImageData = { singleImageId: '', imageName: '', imageFileType: '', imageUrl: '', heading: '', body: '', size: GlobalConstants.MEDIUM, position: 'i-center' }
        videoData = { videoId: '', videoName: '', videoFileType: '', videoUrl: '', heading: '', body: '', size: GlobalConstants.MEDIUM, position: 'v-center' }
        hotspotImageVideoData = { imageAId: '', imageAName: '', imageAFileType: '', imageAUrl: '', heading: '', body: '', bodySize: GlobalConstants.MEDIUM, position: 'h-left', headingColor: '', bodyColor: '', videoId: '', videoName: '', videoFileType: '', videoUrl: '', hotspotNum: '' }
        this.pageGrpForm.imageBContent = imageBData;
        this.pageGrpForm.heroImageContent = heroImageData;
        this.pageGrpForm.singleImageContent = singleImageData;
        this.pageGrpForm.videoContent = videoData;
        this.pageGrpForm.layoutContent.push(heroImageData, singleImageData, videoData);
      } else if (ele.alignment === 'i-center') {
        singleImageData = {
          singleImageId: ele.assetID,
          imageName: ele.assetName,
          imageFileType: ele.assetType,
          imageUrl: (ele.assetID) ? environment.apiBaseUrlAsset + this.url + this.selectAutoId + OemConstants.SLASH_ASSETS + OemConstants.SLASH_IMAGE + AssetLibraryConstants.SLASH + ele.assetID : '',
          heading: ele.title,
          body: ele.subTitle,
          size: this.fontSizeName(ele.fontSize),
          position: ele.alignment
        }
        imageAData = { imageAId: '', imageAName: '', imageAFileType: '', imageAUrl: '', heading: '', bodyA: '', bodyASize: GlobalConstants.MEDIUM, position: 'leftTop' }
        imageBData = { imageBId: '', imageBName: '', imageBFileType: '', imageBUrl: '', heading: '', bodyB: '', bodyBSize: GlobalConstants.MEDIUM, position: 'leftBottom' }
        heroImageData = { heroImageId: '', heroImageName: '', heroImageFileType: '', heroImageUrl: '', heading: '', body: '', size: GlobalConstants.MEDIUM, position: 'right' }
        hotspotImageVideoData = { imageAId: '', imageAName: '', imageAFileType: '', imageAUrl: '', heading: '', body: '', bodySize: GlobalConstants.MEDIUM, position: 'h-left', headingColor: '', bodyColor: '', videoId: '', videoName: '', videoFileType: '', videoUrl: '', hotspotNum: '' }
        videoData = { videoId: '', videoName: '', videoFileType: '', videoUrl: '', heading: '', body: '', size: GlobalConstants.MEDIUM, position: 'v-center' }
        this.pageGrpForm.imageAContent = imageAData;
        this.pageGrpForm.imageBContent = imageBData;
        this.pageGrpForm.heroImageContent = heroImageData;
        this.pageGrpForm.singleImageContent = singleImageData;
        this.pageGrpForm.videoContent = videoData;
        this.pageGrpForm.heroImageContent.heading = this.pageGrpForm.singleImageContent.heading;
        this.pageGrpForm.layoutContent.push(imageAData, imageBData, heroImageData, singleImageData, videoData);
      } else if (ele.alignment === 'h-left') {
        hotspotImageVideoData = {
          imageAId: ele.assetID,
          imageAName: ele.assetName,
          imageAFileType: ele.assetType,
          imageAUrl: (ele.assetID) ? environment.apiBaseUrlAsset + this.url + this.selectAutoId + OemConstants.SLASH_ASSETS + OemConstants.SLASH_IMAGE + AssetLibraryConstants.SLASH + ele.assetID : '',
          heading: ele.title,
          body: ele.subTitle,
          bodySize: this.fontSizeName(ele.fontSize),
          position: ele.alignment,
          videoId: ele.assetID,
          videoName: ele.assetName,
          videoFileType: ele.assetType,
          videoUrl: (ele.assetID) ? environment.apiBaseUrlAsset + this.url + this.selectAutoId + OemConstants.SLASH_ASSETS + OemConstants.SLASH_VIDEO + AssetLibraryConstants.SLASH + ele.assetID : '',
          headingColor: ele.headingColor,
          bodyColor: ele.bodyColor,
          hotspotNum: this.currentTabValue
        }
        imageAData = { imageAId: '', imageAName: '', imageAFileType: '', imageAUrl: '', heading: '', bodyA: '', bodyASize: GlobalConstants.MEDIUM, position: 'leftTop' }
        imageBData = { imageBId: '', imageBName: '', imageBFileType: '', imageBUrl: '', heading: '', bodyB: '', bodyBSize: GlobalConstants.MEDIUM, position: 'leftBottom' }
        heroImageData = { heroImageId: '', heroImageName: '', heroImageFileType: '', heroImageUrl: '', heading: '', body: '', size: GlobalConstants.MEDIUM, position: 'right' }
        videoData = { videoId: '', videoName: '', videoFileType: '', videoUrl: '', heading: '', body: '', size: GlobalConstants.MEDIUM, position: 'v-center' }
        singleImageData = { singleImageId: '', imageName: '', imageFileType: '', imageUrl: '', heading: '', body: '', size: GlobalConstants.MEDIUM, position: 'i-center' }
        this.pageGrpForm.imageAContent = imageAData;
        this.pageGrpForm.imageBContent = imageBData;
        this.pageGrpForm.heroImageContent = heroImageData;
        this.pageGrpForm.singleImageContent = singleImageData;
        this.pageGrpForm.videoContent = videoData;
        this.pageGrpForm.hotspotImageVideoContent = hotspotImageVideoData;
        this.pageGrpForm.layoutContent.push(imageAData, imageBData, heroImageData, singleImageData, videoData);
        this.pageGrpForm.HotspotContent.push(hotspotImageVideoData);
      }
      else {
        videoData = {
          videoId: ele.assetID,
          videoName: ele.assetName,
          videoFileType: ele.assetType,
          videoUrl: (ele.assetID) ? environment.apiBaseUrlAsset + this.url + this.selectAutoId + OemConstants.SLASH_ASSETS + OemConstants.SLASH_VIDEO + AssetLibraryConstants.SLASH + ele.assetID : '',
          heading: ele.title,
          body: ele.subTitle,
          size: this.fontSizeName(ele.fontSize),
          position: ele.alignment
        }
        imageAData = { imageAId: '', imageAName: '', imageAFileType: '', imageAUrl: '', heading: '', bodyA: '', bodyASize: GlobalConstants.MEDIUM, position: 'leftTop' }
        imageBData = { imageBId: '', imageBName: '', imageBFileType: '', imageBUrl: '', heading: '', bodyB: '', bodyBSize: GlobalConstants.MEDIUM, position: 'leftBottom' }
        heroImageData = { heroImageId: '', heroImageName: '', heroImageFileType: '', heroImageUrl: '', heading: '', body: '', size: GlobalConstants.MEDIUM, position: 'right' }
        singleImageData = { singleImageId: '', imageName: '', imageFileType: '', imageUrl: '', heading: '', body: '', size: GlobalConstants.MEDIUM, position: 'i-center' }
        hotspotImageVideoData = { imageAId: '', imageAName: '', imageAFileType: '', imageAUrl: '', heading: '', body: '', bodySize: GlobalConstants.MEDIUM, position: 'h-left', headingColor: '', bodyColor: '', videoId: '', videoName: '', videoFileType: '', videoUrl: '', hotspotNum: '' }
        this.pageGrpForm.imageAContent = imageAData;
        this.pageGrpForm.imageBContent = imageBData;
        this.pageGrpForm.heroImageContent = heroImageData;
        this.pageGrpForm.singleImageContent = singleImageData;
        this.pageGrpForm.videoContent = videoData;
        this.pageGrpForm.heroImageContent.heading = this.pageGrpForm.videoContent.heading;
        this.pageGrpForm.layoutContent.push(imageAData, imageBData, heroImageData, singleImageData, videoData);
      }
    });
    if (page?.hotspots) {
      this.addCurrentHotspotData(page, this.pageGrpForm.hotSpotCurrentTab);
      this.pageGrpForm.hotspots = page.hotspots;
       this.saveHotspot();//TO keep the hotspot data ready.
      if (Object.keys(this.pageGrpForm.hotspots).length !== 0) {
        for (let i = 1; i < Object.keys(this.pageGrpForm.hotspots)?.length; i++) {
          this.tabs.push({ id: i + 1, name: `Hotspot ${i + 1}`, heading: `Heading ${i + 1}`, visited: false });
        }
      }
    }
  }

  update(configurations, page?: number) {
    if (configurations) {
      setTimeout(() => {
        if (typeof configurations === 'string') {
          configurations = JSON.parse(configurations) as PartnerContentConfiguration;
        }
        this.selectedPartnerContentGroupPage = configurations.contentGroupPages?.filter(ele => ele.pageNum === this.pageNumber)[0];
        this.contentName = configurations.contentName;
        this.systemID = configurations.systemID;
        this.prepareContentPage();
        this.pageGrpForm.pageNum =  this.pageNumber;
        this.getImageStatus();
      })
    } else {
      this.selectedPartnerContentGroupPage = undefined;
      this.prepareContentPage();
      this.sendImageValues.emit(true);
    }
  }

  emitPageDataToPreview(onlytopreview?: string) {
    this.pageGrpForm.hotSpotCurrentTab = this.selectedTabIndex;
    if (onlytopreview) {
      this.cmnSer.emitPageData(this.contentGroupType, this.pageNumber, this.pageGrpForm, onlytopreview);
    } else {
      this.cmnSer.emitPageData(this.contentGroupType, this.pageNumber, this.pageGrpForm, '', this.storeImageData);
    }
  }

  openPopup(modal, type) {
    this.image = [];
    this.tileVideo = [];
    this.modalService.open(modal);
    this.disableImage = !this.selectedImage ? this.disableImage : !this.disableImage;
    this.disableVideo = !this.selectedVideo ? this.disableVideo : !this.disableVideo;
    this.disableThumbnail = (!this.selectedImage || !this.selectedVideo) ? this.disableThumbnail : !this.disableThumbnail;
    this.imageButtonType = type;
    if (this.imageButtonType === 'logo') {
      this.type = OemConstants.LOGO;
      this.getType = OemConstants.SLASH_LOGO;
    }
    else {
      this.type = OemConstants.IMAGE;
      this.getType = OemConstants.SLASH_IMAGE;
    }
    this.isAssetDataEmpty = false;
    this.isVideoAssetDataEmpty = false;
    this.isImageVideoButton = false;
    this.getAllImagesByAutoId();
    if (this.imageButtonType === 'video') {
      this.isVideoButton = true;
      this.isImageVideoButton = false;
      this.getAllVideoByAutoId();
    } else {
      this.isVideoButton = false;
    }
    if (this.imageButtonType === 'image-video') {
      this.selectedFilter = 'All';
      this.isImageVideoButton = true;
      this.isVideoButton = false;
      this.getAllVideoByAutoId();
    }
    else {
      this.isImageVideoButton = false;
    }
  }

  // To Know Image and Video records exists or not.
  imageRecords() {
    if ((this.imageButtonType === 'image' || this.imageButtonType === 'hero' ||
      this.imageButtonType === 'imageA' || this.imageButtonType === 'imageB'
    ) && !this.image.length) {
      this.imageAvailable = true;
      this.logoAvailable = false;
    } else if (this.imageButtonType === 'video' && !this.tileVideo.length) {
      this.videoAvailable = true;
      this.logoAvailable = false;
    } else if (this.imageButtonType === 'logo' && !this.image.length) {
      this.logoAvailable = true;
      this.imageAvailable = false;
    } else if (this.imageButtonType === 'image-video' && (!this.image.length || !this.tileVideo.length)) {
      this.imageAvailable = true;
      this.videoAvailable = true;
      this.logoAvailable = false;
    }
    else {
      this.videoAvailable = false;
      this.imageAvailable = false;
      this.logoAvailable = false;
    }
  }
  getAllImagesByAutoId() {
    this.oemservice.getAllAssetsByAutoIdForContent(this.type, this.selectAutoId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(getAllImageResponse => {
        const image = [];
        const getImageByAutoId: GetAllImageByAutoId = getAllImageResponse as GetAllImageByAutoId;
        this.assetsData = getImageByAutoId.assets;
        this.isAssetDataEmpty = (this.assetsData.length === 0) || false;
        this.imageRecords();
        getImageByAutoId.assets.forEach(assets => {
          const reader = new FileReader();
          const imageViewModel: AssetImageViewModel = assets as AssetImageViewModel;

          this.oemservice.getAssetByAutoIdAndAssetIdForContent(assets.assetID, this.getType, this.selectAutoId)
            .pipe(takeUntil(this.ngUnsubscribe))
            .pipe(first())
            .subscribe(imageData => {
              reader.addEventListener('load', () => {
                imageViewModel.imageData = reader.result;
                imageViewModel.fileName = assets.assetName;
                this.image.push(imageViewModel);
                for (let i = 0; i < this.image.length; i++) {
                  if (this.image[i].assetID === this.pageGrpForm.heroImageContent.heroImageId && this.imageButtonType === 'hero') {
                    this.image[i].selectedImage = true;
                    this.imageSelected.fileName = this.pageGrpForm.heroImageContent.heroImageName;
                    this.imageSelected.assetName = this.pageGrpForm.heroImageContent.heroImageName;;
                    this.imageSelected.assetID = this.pageGrpForm.heroImageContent.heroImageId;
                    this.disableImage = false;
                    break;
                  }
                  if (this.image[i].assetID === this.pageGrpForm.imageAContent.imageAId && this.imageButtonType === 'imageA') {
                    this.image[i].selectedImage = true;
                    this.imageSelected.fileName = this.pageGrpForm.imageAContent.imageAName;
                    this.imageSelected.assetName = this.pageGrpForm.imageAContent.imageAName;
                    this.imageSelected.assetID = this.pageGrpForm.imageAContent.imageAId;
                    this.disableImage = false;
                    break;
                  }
                  if (this.image[i].assetID === this.pageGrpForm.imageBContent.imageBId && this.imageButtonType === 'imageB') {
                    this.image[i].selectedImage = true;
                    this.imageSelected.fileName = this.pageGrpForm.imageBContent.imageBName;
                    this.imageSelected.assetName = this.pageGrpForm.imageBContent.imageBName;
                    this.imageSelected.assetID = this.pageGrpForm.imageBContent.imageBId;
                    this.disableImage = false;
                    break;
                  }
                  if (this.image[i].assetID === this.pageGrpForm.logoMedia.logoAssetId && this.imageButtonType === 'logo') {
                    this.image[i].selectedImage = true;
                    this.imageSelected.fileName = this.pageGrpForm.logoMedia.name;
                    this.imageSelected.assetName = this.pageGrpForm.logoMedia.name;
                    this.imageSelected.assetID = this.pageGrpForm.logoMedia.logoAssetId;
                    this.disableImage = false;
                    break;
                  }
                  if (this.image[i].assetID === this.pageGrpForm.singleImageContent.singleImageId && this.imageButtonType === 'image') {
                    this.image[i].selectedImage = true;
                    this.imageSelected.fileName = this.pageGrpForm.singleImageContent.imageName;
                    this.imageSelected.assetName = this.pageGrpForm.singleImageContent.imageName;
                    this.imageSelected.assetID = this.pageGrpForm.singleImageContent.imageassetId;
                    this.disableImage = false;
                    break;
                  }
                  if (this.pageGrpForm?.hotspots[`hotspot${this.currentTabValue}`] && this.pageGrpForm.hotspots[`hotspot${this.currentTabValue}`].assetID) {
                    if (this.image[i]?.assetID && Object.keys(this.pageGrpForm?.hotspots).length > 0) {
                      if (this.image[i]?.assetID === this.pageGrpForm.hotspots[`hotspot${this.currentTabValue}`].assetID && this.imageButtonType === 'image-video') {
                        this.image[i].selectedImage = true;
                        this.imageSelected.fileName = this.pageGrpForm.hotspots[`hotspot${this.currentTabValue}`].assetName;
                        this.imageSelected.assetName = this.pageGrpForm.hotspots[`hotspot${this.currentTabValue}`].assetName;
                        this.imageSelected.assetID = this.pageGrpForm.hotspots[`hotspot${this.currentTabValue}`].assetID;
                        this.disableImage = false;
                        break;
                      }
                    }
                  }
                  else {
                    this.disableImage = true;
                  }
                  this.image[i].shortFileName = this.getShortFileName(this.image[i].fileName);
                  this.image[i].updatedTime = new Date(this.image[i].updatedTime);
                  this.image[i].updateTimeDisplay = new Date(this.image[i].updatedTime).toLocaleString()
                    .replace(',', '');
                }
                this.sortBy('uploadDate');
                this.imageRecords();
              }, false)

              if (imageData) {
                reader.readAsDataURL(imageData);
              }
            },

              error => {
                // do something
              });
        })

      },
        error => {
          // do something
        });
  }

  getAllVideoByAutoId() {
    this.oemservice.getAllAssetsByAutoIdForPartnerContent('Video', this.selectAutoId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(getAllVideoResponse => {
        const getVideoByAutoId = getAllVideoResponse;
        this.videoAssetsData = getVideoByAutoId.assets;
        this.isVideoAssetDataEmpty = (this.videoAssetsData.length === 0) || false;
        const counter = 0;
        this.imageRecords();
        getVideoByAutoId.assets.forEach((assets, index, arrayData) => {
          const reader = new FileReader();
          const VideoViewModel = assets;
          this.oemservice.getAssetByAutoIdAndAssetIdForContent(assets.assetID, OemConstants.SLASH_VIDEO, this.selectAutoId)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(videoData => {
              reader.onload = _event => {
                VideoViewModel.videoData = reader.result;
                VideoViewModel.fileName = assets.assetName;
                this.tileVideo.push(VideoViewModel);
                for (let i = 0; i < this.tileVideo.length; i++) {
                  if (this.tileVideo[i].assetID === this.pageGrpForm.videoContent.videoId && this.imageButtonType === 'video') {
                    this.tileVideo[i].selectedVideo = true;
                    this.imageSelected.fileName = this.pageGrpForm.videoContent.videoName;
                    this.imageSelected.assetName = this.pageGrpForm.videoContent.videoName;
                    this.imageSelected.assetID = this.pageGrpForm.videoContent.videoId;
                    this.disableVideo = false;
                    break;
                  } 
                  if (this.pageGrpForm?.hotspots[`hotspot${this.currentTabValue}`] && this.pageGrpForm.hotspots[`hotspot${this.currentTabValue}`].assetID) {
                    if (this.tileVideo[i]?.assetID && Object.keys(this.pageGrpForm?.hotspots).length > 0) {
                      if (this.tileVideo[i]?.assetID === this.pageGrpForm.hotspots[`hotspot${this.currentTabValue}`].assetID && this.imageButtonType === 'image-video') {
                        this.tileVideo[i].selectedVideo = true;
                        this.imageSelected.fileName = this.pageGrpForm.hotspots[`hotspot${this.currentTabValue}`].assetName;
                        this.imageSelected.assetName = this.pageGrpForm.hotspots[`hotspot${this.currentTabValue}`].assetName;
                        this.imageSelected.assetID = this.pageGrpForm.hotspots[`hotspot${this.currentTabValue}`].assetID;
                        this.disableVideo = false;
                        break;
                      }
                    }
                  }
                  else {
                    this.disableVideo = true;
                  }
                  this.tileVideo[i].shortFileName = this.getShortFileName(this.tileVideo[i].fileName);
                  this.tileVideo[i].updatedTime = new Date(this.tileVideo[i].updatedTime);
                  this.tileVideo[i].updateTimeDisplay = new Date(this.tileVideo[i].updatedTime).toLocaleString()
                    .replace(',', '');
                }
                this.imageRecords();
                this.videoCount = this.tileVideo.length;
                if (this.videoCount === arrayData.length) {
                  this.changeSortType('date');
                }
              };
              if (videoData) {
                reader.readAsDataURL(videoData);
              }

            });
        })
      });
  }

  changeSortType(data) {
    this.setLable = data === 'date' ? this.uploadDateLable : this.fileNameLable;
    if (data === 'name') {
      this.tileVideo.sort((e1, e2): number => {
        if (e1.fileName < e2.fileName) {
          return -1;
        }
        return 0;
      })
    } else {
      this.tileVideo.sort((e1, e2): number => {
        if (new Date(e1.updateTimeDisplay) < new Date(e2.updateTimeDisplay)) {
          return -1;
        }
        return 0;
      })
    }
  }

  getShortFileName(fileName: string): string {
    let finalName: string;
    if (fileName?.split('.')[0].length > 12) {
      let flname = fileName;
      let extension = fileName.substring(fileName.lastIndexOf('.') + 1);
      flname = fileName.substring(0, 12);
      finalName = `${flname}...${extension}`;
    } else {
      finalName = fileName;
    }
    return finalName;
  }

  sortBy(sortValue: string) {
    switch (sortValue) {
      case 'uploadDate': {
        this.uploadImageSortValue = GlobalConstants.UPLOAD_DATE;
        this.image.sort((image1, image2) => (image2.updatedTime as any) - (image1.updatedTime as any));
        break;
      }
      case 'fileName': {
        this.uploadImageSortValue = GlobalConstants.FILE_NAME;
        this.image.sort((image1, image2) =>
          image1.assetName.localeCompare(image2.assetName));
        break;
      }
      default:
        break;
    }
  }

  selectImage(id: string, event, layout: string) {
    if (layout === 'hotspot') {
      this.tileVideo.forEach(video => video.selectedVideo = false);
    }
    this.image.forEach(ele => {
      if (ele.assetID === id) {
        this.imageSelected = event;
        this.pageGrpForm.singleImageContent.imageUrl = event.imageData;
        this.imagePreview = event.imageData;
        ele.selectedImage = true;
        this.disableImage = false;
      } else {
        ele.selectedImage = false;
      }
    });
  }

  selectVideo(id: string, event, layout: string) {
    if (layout === 'hotspot') {
      this.image.forEach(image => image.selectedImage = false);
    }
    this.tileVideo.forEach(ele => {
      if (ele.assetID === id) {
        this.imageSelected = event;
        this.pageGrpForm.videoContent.videoUrl = event.imageData;
        this.imagePreview = event.videoData;
        ele.selectedVideo = true;
        this.disableVideo = false;
      } else {
        ele.selectedVideo = false;
      }
    });
  }

  addImage(modal) {
    this.pageGrpForm.imageType = this.imageButtonType;
    this.pageGrpForm.singleImageContent.imageUrl = '';
    this.storeImageData.set(this.imageButtonType,
      [this.pageGrpForm.singleImageContent.imageUrl,
      this.imageSelected.fileName, this.imageSelected.shortFileName,
      this.imageSelected.imageData.split('/')[1].split(';')[0], this.imageSelected.assetID]);
    this.imageMediaUrl = environment.apiBaseUrlAsset + this.url + this.selectAutoId + OemConstants.SLASH_ASSETS
      + OemConstants.SLASH_IMAGE + AssetLibraryConstants.SLASH;
    this.logoMediaUrl = environment.apiBaseUrlAsset + this.url + this.selectAutoId + OemConstants.SLASH_ASSETS
      + OemConstants.SLASH_LOGO + AssetLibraryConstants.SLASH;
    if (this.storeImageData.has('image')) {
      this.setUploadedAssetData(this.storeImageData, 'i-center');
    }
    if (this.storeImageData.has('hero')) {
      this.setUploadedAssetData(this.storeImageData, 'right');
    }
    if (this.storeImageData.has('imageA')) {
      this.setUploadedAssetData(this.storeImageData, 'leftTop');
    }
    if (this.storeImageData.has('imageB')) {
      this.setUploadedAssetData(this.storeImageData, 'leftBottom');
    }
    if (this.storeImageData.has('logo')) {
      this.pageGrpForm.logoMedia.name = this.storeImageData.get('logo')[1];
      this.pageGrpForm.logoMedia.format = this.storeImageData.get('logo')[3];
      this.pageGrpForm.logoMedia.logoAssetId = this.storeImageData.get('logo')[4];
      this.pageGrpForm.logoMedia.url = this.logoMediaUrl + this.storeImageData.get('logo')[4];
      this.storeImageData.delete('image-video');
      this.storeImageData.delete('logo');
    }
    if (this.storeImageData.has('image-video')) {
      this.setUploadedAssetData(this.storeImageData, 'h-left');
    }
    this.getImageStatus();
    this.emitPageDataToPreview();
    modal.close();
    this.image = [];
  }

  addVideo(modal) {
    this.pageGrpForm.imageType = this.imageButtonType;
    this.pageGrpForm.videoContent.videoUrl = '';
    this.storeImageData.set(this.imageButtonType, [this.pageGrpForm.videoContent.videoUrl, this.imageSelected.fileName,
    this.imageSelected.shortFileName, this.imageSelected.videoData.split('/')[1]
      .split(';')[0], this.imageSelected.assetID]);
    if (this.storeImageData.has('video')) {
      this.setUploadedAssetData(this.storeImageData, 'v-center');
    }
    if (this.storeImageData.has('image-video')) {
      this.setUploadedAssetData(this.storeImageData, 'h-left');
    }
    this.getImageStatus();
    this.emitPageDataToPreview();
    modal.close();
    this.tileVideo = [];
  }

  setUploadedAssetData(imageData, position) {
    this.imageMediaUrl = environment.apiBaseUrlAsset + this.url + this.selectAutoId + OemConstants.SLASH_ASSETS
      + OemConstants.SLASH_IMAGE + AssetLibraryConstants.SLASH;
    this.videoMediaUrl = environment.apiBaseUrlAsset + this.url + this.selectAutoId + OemConstants.SLASH_ASSETS
      + OemConstants.SLASH_VIDEO + AssetLibraryConstants.SLASH;

    this.pageGrpForm.layoutContent.forEach(element => {
      if (position === 'leftTop') {
        element.imageAId = imageData.get('imageA')[4];
        element.imageAName = imageData.get('imageA')[1];
        element.imageAFileType = imageData.get('imageA')[3];
        element.imageAUrl = this.imageMediaUrl + imageData.get('imageA')[4];
        this.pageGrpForm.imageAContent.imageAName = element.imageAName;
      } else if (position === 'leftBottom') {
        element.imageBId = imageData.get('imageB')[4];
        element.imageBName = imageData.get('imageB')[1];
        element.imageBFileType = imageData.get('imageB')[3];
        element.imageBUrl = this.imageMediaUrl + imageData.get('imageB')[4];
        this.pageGrpForm.imageBContent.imageAName = element.imageBName;
      } else if (position === 'right') {
        element.heroImageId = imageData.get('hero')[4];
        element.heroImageName = imageData.get('hero')[1];
        element.heroImageFileType = imageData.get('hero')[3];
        element.heroImageUrl = this.imageMediaUrl + imageData.get('hero')[4];
        this.pageGrpForm.heroImageContent.heroImageName = element.heroImageName;
      } else if (position === 'i-center') {
        element.singleImageId = imageData.get('image')[4];
        element.imageName = imageData.get('image')[1];
        element.imageFileType = imageData.get('image')[3];
        element.imageUrl = this.imageMediaUrl + imageData.get('image')[4];
        this.pageGrpForm.singleImageContent.imageName = element.imageName;
      } else if (position === 'v-center') {
        element.videoId = imageData.get('video')[4];
        element.videoName = imageData.get('video')[1];
        element.videoFileType = imageData.get('video')[3];
        element.videoUrl = this.videoMediaUrl + imageData.get('video')[4];
        this.pageGrpForm.videoContent.videoName = element.videoName;
      }
    });
    this.selectImageVideoHotspotData = [];
    let selectImageVideoHotspotDataObj = {
      imageAId: '',
      imageAName: '',
      imageAFileType: '',
      imageAUrl: '',
      videoName: '',
      videoId: '',
      videoFileType: '',
      videoUrl: ''
    }
    this.selectImageVideoHotspotData.push(selectImageVideoHotspotDataObj);
    this.selectImageVideoHotspotData.forEach(element => {
      if (position === 'h-left') {
        if (this.imageSelected.selectedImage) {
          element.imageAId = imageData.get('image-video')[4];
          element.imageAName = imageData.get('image-video')[1];
          element.imageAFileType = imageData.get('image-video')[3];
          element.imageAUrl = this.imageMediaUrl + imageData.get('image-video')[4];
        } else if (this.imageSelected.selectedVideo) {
          element.videoId = imageData.get('image-video')[4];
          element.videoName = imageData.get('image-video')[1];
          element.videoFileType = imageData.get('image-video')[3];
          element.videoUrl = this.videoMediaUrl + imageData.get('image-video')[4];
        }
        this.saveHotspot();
      }
    });
  }

  closePopup(modal) {
    modal.close();
    this.image = [];
    this.disableImage = true;
    this.disableVideo = true;
    this.tileVideo = [];
  }

  checkVideoPlay(data) {
    data.preventDefault();
    if (!this.videoPlaying) {
      this.videoPlaying = data.target;
      this.videoPlaying.play();
    } else {
      if (data.target !== this.videoPlaying) {
        this.videoPlaying.pause();
        this.videoPlaying = data.target;
        this.videoPlaying.play();
      }
    }
  }

  chooseTheme(fontColor: string, bgColor: string) {
    [
      this.pageGrpForm.bgcolor,
      this.pageGrpForm.hcolor,
      this.pageGrpForm.bcolor
    ] =
      [
        bgColor,
        fontColor,
        fontColor
      ];
    if (this.pageGrpForm.layout === 4) {
      this.isFontColorStruckOff = false;
      this.saveHotspot();
      this.onFontThemeChangeHotspots();
    }
    this.dismiss();
    this.emitPageDataToPreview();
  }

  openColPicModal() {
    this.modalRef = this.modalService.open(this.colPicModal);
    this.modalRef.result.then();
  }

  dismiss() {
    this.modalRef.close();
  }

  selectSize(size) {
    switch (size) {
      case 'Small': {
        this.pageGrpForm.singleImageContent.size = GlobalConstants.SMALL;
        break;
      }
      case 'Medium': {
        this.pageGrpForm.singleImageContent.size = GlobalConstants.MEDIUM;
        break;
      }
      case 'Large': {
        this.pageGrpForm.singleImageContent.size = GlobalConstants.LARGE;
        break;
      }
      default:
        break;
    }
    this.emitPageDataToPreview();
  }

  fontSize(size) {
    if (size === GlobalConstants.SMALL) { return GlobalConstants.FONTSIZE_12PX; }
    if (size === GlobalConstants.MEDIUM) { return GlobalConstants.FONTSIZE_14PX; }
    if (size === GlobalConstants.LARGE) { return GlobalConstants.FONTSIZE_16PX; }
  }

  fontSizeName(size) {
    if (size === GlobalConstants.FONTSIZE_12PX) { return GlobalConstants.SMALL; }
    if (size === GlobalConstants.FONTSIZE_14PX) { return GlobalConstants.MEDIUM; }
    if (size === GlobalConstants.FONTSIZE_16PX) { return GlobalConstants.LARGE; }
  }

  getFontSize(size) {
    if (size > GlobalConstants.NUMBER_0 && size <= GlobalConstants.NUMBER_12) { return GlobalConstants.SMALL; }
    if (size > GlobalConstants.NUMBER_12 && size <= GlobalConstants.NUMBER_14) { return GlobalConstants.MEDIUM; }
    if (size > GlobalConstants.NUMBER_14) { return GlobalConstants.LARGE; }
  }

  isSelected(bcolor, bgcolor) {
    if (this.pageGrpForm.bcolor === bcolor && this.pageGrpForm.bgcolor === bgcolor) {
      return true;
    }

    return false;
  }

  selectSizeA(size) {
    switch (size) {
      case 'Small': {
        this.pageGrpForm.imageAContent.bodyASize = GlobalConstants.SMALL;
        break;
      }
      case 'Medium': {
        this.pageGrpForm.imageAContent.bodyASize = GlobalConstants.MEDIUM;
        break;
      }
      case 'Large': {
        this.pageGrpForm.imageAContent.bodyASize = GlobalConstants.LARGE;
        break;
      }
      default:
        break;
    }
    this.emitPageDataToPreview();
  }

  selectSizeB(size) {
    switch (size) {
      case 'Small': {
        this.pageGrpForm.imageBContent.bodyBSize = GlobalConstants.SMALL;
        break;
      }
      case 'Medium': {
        this.pageGrpForm.imageBContent.bodyBSize = GlobalConstants.MEDIUM;
        break;
      }
      case 'Large': {
        this.pageGrpForm.imageBContent.bodyBSize = GlobalConstants.LARGE;
        break;
      }
      default:
        break;
    }
    this.emitPageDataToPreview();
  }

  getUILayoutIDByName(name) {
    if (name === '3-asset-layout') {
      return 1;
    } else if (name === '1-image-layout') {
      return 2;
    } else if (name === '1-video-layout') {
      return 3;
    } else if (name === '1-hotspot-layout') {
      return 4;
    }
  }

  getImageStatus() {
    if (this.pageGrpForm.layout === 1) {
      if (this.pageGrpForm.imageAContent.imageAName === '' || this.pageGrpForm.imageBContent.imageBName === ''
        || this.pageGrpForm.heroImageContent.heroImageName === '') {
        this.sendImageValues.emit(true);
      } else {
        this.sendImageValues.emit(false);
      }
    } else if (this.pageGrpForm.layout === 2) {
      if (this.pageGrpForm.singleImageContent.imageName === '') {
        this.sendImageValues.emit(true);
      } else {
        this.sendImageValues.emit(false);
      }
    } else if (this.pageGrpForm.layout === 3) {
      if (this.pageGrpForm.videoContent.videoName === '') {
        this.sendImageValues.emit(true);
      } else {
        this.sendImageValues.emit(false);
      }
    } else if (this.pageGrpForm.layout === 4) {
      const heading = this.pageGrpForm?.hotspotImageVideoContent?.heading;
      if (heading && heading.trim() !== '') {
        this.showHeadingMessage = false;
      } 
      if (this.selectImageVideoHotspotData?.length && this.selectImageVideoHotspotData !== undefined) {
        this.showImageVideoMessage = false;
      }
      if (this.selectImageVideoHotspotData?.length && this.selectImageVideoHotspotData !== undefined && heading && heading.trim() !== '') {
        this.sendImageValues.emit(false);
        this.disabledSaveHotspot = false;
      } else {
        this.sendImageValues.emit(true);
        this.disabledSaveHotspot = true;
      }
    }

  }

  redirectToModelSku(modal) {
    modal.close();
    this.router.navigate([RouterConstants.EDIT_SKU, this.selectAutoId]);
  }

  selectTab(index: number) {
    this.selectedTabIndex = index;
    this.currentTabValue = index + 1;
    this.tabs[index].visited = true;
    this.pageGrpForm.hotspotImageVideoContent.bodyFontSize =  
    this.pageGrpForm.hotspots[`hotspot${this.currentTabValue}`]?.bodyFontSize ;
    this.addCurrentHotspotData(this.pageGrpForm, index);
    this.pageGrpForm.hotSpotCurrentTab = index;
    this.getImageStatus();
    this.cmnSer.emitPageData(this.contentGroupType, this.pageNumber, this.pageGrpForm);
  }



  addTab() {
    this.showHeadingMessage = (this.pageGrpForm?.hotspotImageVideoContent?.heading === '' || this.pageGrpForm?.hotspotImageVideoContent?.heading?.trim() === '' || this.pageGrpForm?.hotspotImageVideoContent?.heading === undefined) ? true : false;
    this.showImageVideoMessage = (this.selectImageVideoHotspotData?.length === 0 || this.selectImageVideoHotspotData === undefined) ? true : false;
    if (this.showHeadingMessage || this.showImageVideoMessage) {
      return;
    }
    this.pageGrpForm.hotspotImageVideoContent = {};
    this.selectImageVideoHotspotData = [];
    this.pageGrpForm.hotspotImageVideoContent.bodyFontSize = GlobalConstants.MEDIUM;
    this.getImageStatus();
    if (this.tabs.length < 4) {
      this.currentTabValue = this.tabs.length + 1;
      this.tabs.push({ id: this.currentTabValue, name: `Hotspot ${this.currentTabValue}`, heading: `Heading ${this.currentTabValue}`, visited: false });
      this.selectTab(this.tabs.length - 1);
    }
    this.addCurrentHotspotData(this.pageGrpForm, this.currentTabValue);
  }

  saveHotspot() {
    const headingColorToUse = this.isFontColorStruckOff
      ? this.pageGrpForm?.hotspotImageVideoContent?.headingColor
      : this.pageGrpForm.hcolor;
    const bodyColorToUse = this.isFontColorStruckOff
      ? this.pageGrpForm?.hotspotImageVideoContent?.bodyColor
      : this.pageGrpForm.hcolor;
    let newHotspotImageVideoDataObj: HotspotImageVideoContent = {
      assetID: (this.selectImageVideoHotspotData[0]?.imageAId || this.selectImageVideoHotspotData[0]?.videoId) || '',
      assetName: (this.selectImageVideoHotspotData[0]?.imageAName || this.selectImageVideoHotspotData[0]?.videoName) || '',
      assetType: (this.selectImageVideoHotspotData[0]?.imageAFileType || this.selectImageVideoHotspotData[0]?.videoFileType) || '',
      heading: this.pageGrpForm?.hotspotImageVideoContent?.heading || '',
      headingColor: headingColorToUse || '',
      body: this.pageGrpForm?.hotspotImageVideoContent?.body || '',
      bodyColor: bodyColorToUse || '',
      bodyFontSize: this.fontSize(this.pageGrpForm?.hotspotImageVideoContent?.bodyFontSize) || GlobalConstants.MEDIUM,
      assetUrl: (this.selectImageVideoHotspotData[0]?.imageAUrl || this.selectImageVideoHotspotData[0]?.videoUrl) || ''
    }
    if (this.currentTabValue === 1) {
      this.pageGrpForm.hotspots[`hotspot${this.currentTabValue}`] = newHotspotImageVideoDataObj;
    } else if (this.currentTabValue === 2) {
      this.pageGrpForm.hotspots[`hotspot${this.currentTabValue}`] = newHotspotImageVideoDataObj;
    } else if (this.currentTabValue === 3) {
      this.pageGrpForm.hotspots[`hotspot${this.currentTabValue}`] = newHotspotImageVideoDataObj;
    } else if (this.currentTabValue === 4) {
      this.pageGrpForm.hotspots[`hotspot${this.currentTabValue}`] = newHotspotImageVideoDataObj;
    }
    this.emitPageDataToPreview();
  }


  removeTab(index: number, event: Event) {
    this.tabs.splice(index, 1);
    const copyObject=Object.assign({},this.pageGrpForm.hotspots);
    for(let i=1,p=0;i<5;i++){
      if((i==index+1)|| p){
        if(copyObject.hasOwnProperty(`hotspot${i+1}`))
         {
            this.pageGrpForm.hotspots[`hotspot${i}`]={};
            Object.defineProperty(this.pageGrpForm.hotspots, `hotspot${i}`, {value:{}});
            Object.assign(this.pageGrpForm.hotspots[`hotspot${i}`],copyObject[`hotspot${i+1}`]);
         }
        else{ 
          if(copyObject.hasOwnProperty(`hotspot${i}`)){
          delete this.pageGrpForm.hotspots[`hotspot${i}`];
          }
        } p++;
      }
    }
    this.tabs=[];
    if (Object.keys(this.pageGrpForm.hotspots).length !== 0) {
      for (let i = 1; i <= Object.keys(this.pageGrpForm.hotspots)?.length; i++) {
        this.tabs.push({ id: i, name: `Hotspot ${i}`, heading: `Heading ${i}`, visited: (index+1)? true:false });
      }
    }    
    this.selectTab(index>0?(index-1):index);
    if (this.selectedTabIndex >= this.tabs.length) {
      this.selectedTabIndex = this.tabs.length - 1;
    }
  }

  addThumbanail(modal) {
    if (this.imageSelected.selectedImage) {
      this.addImage(modal)
    } else if (this.imageSelected.selectedVideo) {
      this.addVideo(modal);
    }
  }

  selectHotspotBodySize(size) {
    switch (size) {
      case 'Small': {
        this.pageGrpForm.hotspotImageVideoContent.bodyFontSize = GlobalConstants.SMALL;
        break;
      }
      case 'Medium': {
        this.pageGrpForm.hotspotImageVideoContent.bodyFontSize = GlobalConstants.MEDIUM;
        break;
      }
      case 'Large': {
        this.pageGrpForm.hotspotImageVideoContent.bodyFontSize = GlobalConstants.LARGE;
        break;
      }
      default:
        break;
    }
    this.emitHeadingBodyFontSize();
  }

  onFontThemeChangeHotspots() {
    for (let i = 1; i <= 4; i++) {
      if (this.pageGrpForm.hotspots[`hotspot${i}`]) {
        this.pageGrpForm.hotspots[`hotspot${i}`].headingColor = this.pageGrpForm.hcolor;
        this.pageGrpForm.hotspots[`hotspot${i}`].bodyColor = this.pageGrpForm.hcolor;
        if (this.currentTabValue === i) {
          this.pageGrpForm.hotspotImageVideoContent.headingColor = this.pageGrpForm.hcolor;
          this.pageGrpForm.hotspotImageVideoContent.bodyColor = this.pageGrpForm.hcolor;
        }
      }
    }
  }

  onFontColorChange() {
    if (this.pageGrpForm.layout === 4) {
      this.isFontColorStruckOff = false;
      this.saveHotspot();
      this.onFontThemeChangeHotspots();
    } else {
      this.emitPageDataToPreview();
    }
  }

  onHeadingBodyColorChange() {
    this.isFontColorStruckOff = true;
    this.pageGrpForm.hcolor = "";
    this.saveHotspot();
  }

  filterImageOrVideo(index: any) {
    if (index == 'All') {
      this.selectedFilter = 'All';
    }
    else if (index == 'Images') {
      this.selectedFilter = 'Images';
    }
    else {
      this.selectedFilter = 'Videos';
    }
  }

  onHeadingChange(value: string) {
    if (value.length >= 200) {
      this.isHeadingMaxLengthReached = true;
    } else {
      this.isHeadingMaxLengthReached = false;
    }
    this.pageGrpForm.hotspotImageVideoContent.heading = value;
    if (this.pageGrpForm?.hotspotImageVideoContent?.heading && this.pageGrpForm?.hotspotImageVideoContent?.heading.trim() !== '') {
      this.showHeadingMessage = false;
    } else {
      this.showHeadingMessage = true;
    }
    this.emitHeadingBodyFontSize();
  }

  onBodyChange(value: string) {
    if (value.length >= 2000) {
      this.isMaxLengthReached = true;
    } else {
      this.isMaxLengthReached = false;
    }
    this.pageGrpForm.hotspotImageVideoContent.body = value;
    this.emitHeadingBodyFontSize();
  }

  emitHeadingBodyFontSize() {
    this.saveHotspot();
    this.emitPageDataToPreview();
  }
  addCurrentHotspotData(page, tabNum) {
    this.pageGrpForm.HotspotContent = [];//empty the hotspot container data
    if (page?.hotspots) {
      var htspt = `hotspot${tabNum + 1}`, hotspotImageVideoData;
      if (page?.hotspots[htspt]) {
        hotspotImageVideoData = {
          imageAId: page?.hotspots[htspt]?.assetID,
          imageAName: page?.hotspots[htspt]?.assetName,
          imageAFileType: page?.hotspots[htspt]?.assetType,
          imageAUrl: (page?.hotspots[htspt]?.assetID) ? environment.apiBaseUrlAsset + this.url + this.selectAutoId + OemConstants.SLASH_ASSETS + OemConstants.SLASH_IMAGE + AssetLibraryConstants.SLASH + page?.hotspots[htspt]?.assetID : '',
          heading: page?.hotspots[htspt]?.heading,
          body: page?.hotspots[htspt]?.body,
          bodySize: this.fontSizeName(page?.hotspots[htspt]?.bodyFontSize),
          position: "",
          videoId: "",
          videoName: "",
          videoFileType: "",
          videoUrl: '',
          headingColor: page?.hotspots[htspt]?.headingColor,
          bodyColor: page?.hotspots[htspt]?.bodyColor,
          hotspotNum: 0,
          bodyFontSize: this.fontSizeName(page?.hotspots[htspt]?.bodyFontSize)
        }
        this.pageGrpForm.hotspotImageVideoContent = hotspotImageVideoData;
        this.pageGrpForm.HotspotContent.push(hotspotImageVideoData);
        this.isFontColorStruckOff = page?.hotspots[htspt]?.headingColor || page?.hotspots[htspt]?.bodyColor ? true : false;
        this.selectImageVideoHotspotData = [];
        let selectImageVideoHotspotDataObj = {
          imageAId: '',
          imageAName: '',
          imageAFileType: '',
          imageAUrl: '',
          videoName: '',
          videoId: '',
          videoFileType: '',
          videoUrl: ''
        }
        if (page?.hotspots[htspt]?.assetType) {
          if (page?.hotspots[htspt]?.assetType == "png" || page?.hotspots[htspt]?.assetType == "jpg" || page?.hotspots[htspt]?.assetType == "jpeg") {
            selectImageVideoHotspotDataObj.imageAId = page?.hotspots[htspt]?.assetID;
            selectImageVideoHotspotDataObj.imageAName = page?.hotspots[htspt]?.assetName;
            selectImageVideoHotspotDataObj.imageAFileType = page?.hotspots[htspt]?.assetType;
            selectImageVideoHotspotDataObj.imageAUrl = (page?.hotspots[htspt]?.assetID) ? environment.apiBaseUrlAsset + this.url + this.selectAutoId + OemConstants.SLASH_ASSETS + OemConstants.SLASH_IMAGE + AssetLibraryConstants.SLASH + page?.hotspots[htspt]?.assetID : '';
          } else {
            selectImageVideoHotspotDataObj.videoId = page?.hotspots[htspt]?.assetID;
            selectImageVideoHotspotDataObj.videoName = page?.hotspots[htspt]?.assetName;
            selectImageVideoHotspotDataObj.videoFileType = page?.hotspots[htspt]?.assetType;
            selectImageVideoHotspotDataObj.videoUrl = (page?.hotspots[htspt]?.assetID) ? environment.apiBaseUrlAsset + this.url + this.selectAutoId + OemConstants.SLASH_ASSETS + OemConstants.SLASH_VIDEO + AssetLibraryConstants.SLASH + page?.hotspots[htspt]?.assetID : '';
          }
        }
        this.selectImageVideoHotspotData.push(selectImageVideoHotspotDataObj);
      } else {
        hotspotImageVideoData = { assetID: '', assetName: '', assetType: '', heading: '', body: '', bodyFontSize: GlobalConstants.MEDIUM, headingColor: '', bodyColor: '', videoUrl: '', imageAUrl: '' };
        this.pageGrpForm.hotspotImageVideoContent = hotspotImageVideoData;
        if (this.pageGrpForm?.hcolor) {
          this.pageGrpForm.hotspotImageVideoContent.headingColor = this.pageGrpForm.hcolor;
          this.pageGrpForm.hotspotImageVideoContent.bodyColor = this.pageGrpForm.hcolor;
        }
        this.pageGrpForm.HotspotContent.push(hotspotImageVideoData);
        this.selectImageVideoHotspotData = [];
        let selectImageVideoHotspotDataObj = {
          imageAId: '',
          imageAName: '',
          imageAFileType: '',
          imageAUrl: '',
          videoName: '',
          videoId: '',
          videoFileType: '',
          videoUrl: ''
        };
        this.selectImageVideoHotspotData.push(selectImageVideoHotspotDataObj);
      }
    }
  }
}
